module.exports = __webpack_public_path__ + "img/A1916.151e9b4e.png";